import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import ReactLoading from 'react-loading';
import UploadRecord from './upload-records';
import Invoice from './invoice';
import { catchError } from '../../helpers/catch-error-case-manager'
import { useNavigate } from "react-router-dom";
import InputAuto from '../../helpers/input-auto';


const CaseInformation = ({ work_order, onWorkOrderChange, is_loading = true }) => {
    const navigate = useNavigate();
    const DEFAULT_INSTRUCTIONS = "All Records System Wide For Time Frame.";

    const [wo, setWo] = useState({ wo_special_instructions: DEFAULT_INSTRUCTIONS });
    const [customInstructions, setCustomInstructions] = useState(""); // user-added text only

    const [woMask, setWoMask] = useState(true);

    const [isBtn, setIsBtn] = useState(false)
    const [inputError, setInputError] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [orderTypes, setOrderTypes] = useState(null);
    const loginName = localStorage.getItem('@last_name') + " " + localStorage.getItem('@first_name');

    useEffect(() => {

        getOrderTypes();

    }, [])
    useEffect(() => {
        if (work_order?.work_order_id > 0) {

            let w = work_order;
            if (work_order?.needed_by_date)
                w.needed_by_date = w.needed_by_date_f;
            if (!work_order?.wo_admit_date)
                w.wo_admit_date = "5 Year History"

            let initialText = work_order.wo_special_instructions || "";

            if (initialText.startsWith(DEFAULT_INSTRUCTIONS)) {
                initialText = initialText.slice(DEFAULT_INSTRUCTIONS.length).trimStart();
            }
            setCustomInstructions(initialText);
            w.wo_special_instructions = `${DEFAULT_INSTRUCTIONS} ${initialText}`;

            setWo(w);

        }

    }, [work_order?.work_order_id]);




    const getOrderTypes = async (e) => {


        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/get-order-types", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setOrderTypes(response?.data?.order_types);


            } else {

                Swal.fire({ icon: "error", title: "Order Types", text: response?.data?.message });

            }
        }).catch(function (error) {

            catchError(error, navigate)

        });

    }

    const savewo = async (e) => {

        setIsBtn(true);
        const { wo_order_type, wo_admit_date, wo_policy_number } = wo;

        if (!wo_order_type || !wo_admit_date) {

            setInputError(true);
            setIsBtn(false);

        } else {

            if (!wo_policy_number || wo_policy_number == "") {
                await Swal.fire({
                    icon: "info",
                    title: "No Policy Number Entered",
                    text: "You haven’t entered a policy number. You can continue, but it’s recommended to include one."
                });

            }
            var wo_info = {
                work_order_id: work_order?.work_order_id,
                wo_order_type: wo?.wo_order_type,
                wo_policy_number: wo?.wo_policy_number,
                wo_insured: wo?.wo_insured,
                wo_admit_date: wo?.wo_admit_date,
                wo_case_open: wo?.wo_case_open,
                wo_auth_submit: wo?.wo_auth_submit,
                wo_special_instructions: wo?.wo_special_instructions,
                wo_case_instructions: wo?.wo_case_instructions,
                wo_request_submitted_by: wo?.wo_request_submitted_by ? wo?.wo_request_submitted_by : loginName,

            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/case-manager/add-wo", wo_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status && work_order.authorization_status == 1) {
                    navigate("/case-manager/work-orders-active");
                } else if (response?.data?.status) {
                    await Swal.fire({
                        icon: "warning",
                        title: "Your case has been  submitted!",
                        text: "Case has been submitted successfully. Please upload patient authorization.",
                    });
                    window.location.reload();
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Case Info",
                        text: response?.data?.message,
                    });
                }




                if (response?.data?.status) {

                    setWo(wo_info);
                    setEditMode(false)
                    onWorkOrderChange(wo_info);

                    setIsBtn(false)
                } else {
                    Swal.fire({ icon: "error", title: "wo Info", text: response?.data?.message });
                    setIsBtn(false)
                }
            }).catch(function (error) {

                setIsBtn(false);
                catchError(error, navigate)
            });

        }
    }


    const updatewo = async (e) => {

        setIsBtn(true);
        let error_flag = false;

        const { wo_order_type, client_fee, facility_fee, wo_admit_date, wo_policy_number } = wo;

        if (!wo_order_type || !wo_admit_date) {

            setInputError(true);
            setIsBtn(false);

        } else {

            var wo_info = {
                work_order_id: work_order?.work_order_id,
                wo_order_type: wo?.wo_order_type,
                wo_policy_number: wo?.wo_policy_number,
                wo_insured: wo?.wo_insured,
                wo_admit_date: wo?.wo_admit_date,
                wo_case_open: wo?.wo_case_open,
                wo_auth_submit: wo?.wo_auth_submit,
                wo_special_instructions: wo?.wo_special_instructions,
                wo_request_submitted_by: wo?.wo_request_submitted_by,
            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/case-manager/update-wo", wo_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    setWo(wo_info);
                    setEditMode(false)
                    onWorkOrderChange(wo_info);

                } else {

                    Swal.fire({ icon: "error", title: "wo Info", text: response?.data?.message });

                }
                setIsBtn(false)

            }).catch(function (error) {
                setIsBtn(false);
                catchError(error, navigate)
            });

        }


    }

    const toggleWoMask = () => {

        if (woMask) {
            setWoMask(false);
        }
        else {
            setWoMask(true);

        }

    }

    return (
        <>
            <div className="card card-form" >
                <div className="card-body p-0" >

                    <div className=" card-heading row m-0" >
                        <div className="col-md-5 col-sm-12 py-2 ps-3">
                            <h6 className=" fw-bold text-dark mt-0 ">
                                WORK ORDER INFORMATION
                            </h6>
                        </div>
                        {work_order?.status < 7 &&

                            <div className="col-md-7 col-sm-12 text-md-end text-sm-center my-2 ">

                                {!work_order?.wo_order_type || editMode ?
                                    <>
                                        {(work_order?.status > 0) ?
                                            <>
                                                <button onClick={() => updatewo()} className="btn btn-sm  btn-success me-1 " type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "UPDATE"}</button>
                                                <button onClick={() => setEditMode(false)} className="btn btn-sm   btn-warning me-1 " type="button">CANCEL UPDATE</button>
                                            </>
                                            :
                                            <>
                                                <button onClick={() => savewo()} className="btn btn-sm  btn-success me-1 " type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "ADD/UPDATE WO"}</button>
                                                <button onClick={() => setEditMode(false)} className="btn btn-sm   btn-warning me-1 " type="button">CANCEL ADD/UPDATE</button>

                                            </>
                                        }
                                    </>
                                    :
                                    <>
                                        <button onClick={() => setEditMode(true)} className="btn btn-sm    btn-success me-1 " type="button">EDIT</button>
                                        <button onClick={() => toggleWoMask()} className="btn btn-sm btn-warning me-1 " type="button">{woMask ? "UN-MASK" : "MASK"} </button>

                                    </>
                                }

                            </div>
                        }
                    </div>

                    {is_loading ?
                        <div className="text-center m-auto loader" >
                            <ReactLoading type={"cylon"} color={"#54418B"} height={250} width={250} />
                        </div>
                        :

                        <form id="frm_wo" >

                            <div className="row " >

                                <div className="col-xl-12 col-lg-12" >
                                    <div className="" >

                                        {(!work_order?.wo_order_type || editMode) ?

                                            <>
                                                <div className="row px-3 py-3 gx-2 ">

                                                    <div className="col-3 mb-3">
                                                        <label htmlFor="wo_order_type" >ORDER TYPE*</label>

                                                        <select
                                                            name="wo_order_type"
                                                            className="form-select"
                                                            value={wo?.wo_order_type || ""}
                                                            onChange={(e) => setWo({ ...wo, wo_order_type: e.target.value })}
                                                        >
                                                            <option value="">Select Order Type</option>
                                                            {(orderTypes || []).map((item) => (
                                                                <option key={item.id} value={item.type_name}>
                                                                    {item.type_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {inputError && !wo?.wo_order_type &&
                                                            <span className="text-danger">Select work order type</span>
                                                        }

                                                    </div>


                                                    <div className="col-3 mb-3">
                                                        <label htmlFor="wo_request_submitted_by" >Work Order Requested By</label>
                                                        <input name="wo_request_submitted_by" className="form-control"
                                                            value={wo?.wo_request_submitted_by == null ? loginName : wo?.wo_request_submitted_by}
                                                            onChange={(e) =>
                                                                setWo({ ...wo, wo_request_submitted_by: e.target.value })
                                                            }
                                                        />


                                                    </div>






                                                    <div className="col-3 mb-3">
                                                        <label htmlFor="wo_policy_number" >POLICY NUMBER</label>
                                                        <input name="wo_policy_number" className="form-control"
                                                            value={wo?.wo_policy_number}
                                                            onChange={(e) =>
                                                                setWo({ ...wo, wo_policy_number: e.target.value })
                                                            }

                                                        />





                                                    </div>






                                                    <div className="col-3">
                                                        <label htmlFor="wo_insured">PURPOSE/INTENT</label>
                                                        <select name="wo_insured" className=" form-select"
                                                            value={wo?.wo_insured}
                                                            onChange={(e) =>
                                                                setWo({ ...wo, wo_insured: e.target.value })
                                                            }
                                                        >
                                                            <option value="" selected={(!wo?.wo_insured || wo?.wo_insured == "") ? "selected" : ""} ></option>
                                                            <option value="LIFE INSURANCE" selected={(wo?.wo_insured == "LIFE INSURANCE") ? "selected" : ""} >LIFE INSURANCE</option>
                                                            <option value="CLAIMS REVIEW" selected={(wo?.wo_insured == "CLAIMS REVIEW") ? "selected" : ""}>CLAIMS REVIEW</option>
                                                            <option value="THIRD PARTY LIABILITY" selected={(wo?.wo_insured == "THIRD PARTY LIABILITY") ? "selected" : ""}>THIRD PARTY LIABILITY</option>
                                                        </select>

                                                    </div>





                                                    <div className="col-6">
                                                        <label htmlFor="wo_admit_date">ADMISSION TIME PERIOD*</label>
                                                        <div>

                                                            <div className="form-check-inline">

                                                                <input className="me-1 form-check-input" onClick={(e) => setWo({ ...wo, wo_admit_date: "3 Year History" })} type="radio" name="wo_admit_date" value="3 Year History" checked={wo?.wo_admit_date == "3 Year History" ? true : false} />
                                                                <label className="me-0 form-check-label fw-normal"  >3 Years</label>
                                                            </div>
                                                            <div className="form-check-inline">
                                                                <input className="me-1 form-check-input " onClick={(e) => setWo({ ...wo, wo_admit_date: "5 Year History" })} type="radio" name="wo_admit_date" value="5 Year History" checked={wo?.wo_admit_date == "5 Year History" ? true : false} />
                                                                <label className="me-0 form-check-label fw-normal"  >5 Years</label>
                                                            </div>
                                                            <div className="form-check-inline me-0">
                                                                <input className="me-1 form-check-input" onClick={(e) => setWo({ ...wo, wo_admit_date: "" })} type="radio" name="wo_admit_date" value="Other" checked={(wo?.wo_admit_date != "3 Year History" && wo?.wo_admit_date != "5 Year History") ? true : false} />
                                                                <label className="me-0 form-check-label fw-normal"  >Others (specify)</label>
                                                            </div>

                                                            <input name="wo_admit_date_others" className="form-control d-inline w-120 ms-1"
                                                                value={(wo?.wo_admit_date != "3 Year History" && wo?.wo_admit_date != "5 Year History") ? wo?.wo_admit_date : ""}
                                                                onChange={(e) =>
                                                                    setWo({ ...wo, wo_admit_date: e.target.value })
                                                                }

                                                            />


                                                            {inputError &&
                                                                !wo?.wo_admit_date && (
                                                                    <span className="text-danger">Enter admission time period</span>
                                                                )}
                                                        </div>




                                                    </div>










                                                    {!editMode &&
                                                        <div className="col-6 mb-3 mt-4">
                                                            
                                                            <div className="mt-2">
                                                                <div className="form-check-inline">
<label htmlFor="wo_auth_submit">PATIENT AUTHORIZATION FORM: </label>
                                                                    
                                                                    <div className="form-check-inline">
                                                                        <input className="me-1 form-check-input" onClick={(e) => setWo({ ...wo, wo_auth_submit: "Fax" })} type="radio" name="wo_auth_submit" value="Fax" checked={wo?.wo_auth_submit == "Fax" ? true : false} />
                                                                        <label className="me-0 form-check-label fw-normal"  >Fax</label>
                                                                    </div>

                                                                    <div className="form-check-inline">
                                                                        <input className="me-1 form-check-input" onClick={(e) => setWo({ ...wo, wo_auth_submit: "Email" })} type="radio" name="wo_auth_submit" value="Email" checked={(wo?.wo_auth_submit == "Email") ? true : false} />
                                                                        <label className="me-0 form-check-label fw-normal"  >Email</label>
                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>
                                                    }
</div>
<div className="row " >

                                                    <div className="col-6 mb-3">
                                                        <label htmlFor="wo_special_instructions">SPECIAL INSTRUCTIONS : {DEFAULT_INSTRUCTIONS}</label>
                                                        <textarea
                                                            rows="3"
                                                            className="form-control"
                                                            value={customInstructions}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setCustomInstructions(value);
                                                                setWo({ ...wo, wo_special_instructions: `${DEFAULT_INSTRUCTIONS}${value ? " " + value : ""}` });
                                                            }}
                                                        >
                                                        </textarea>
                                                        (Special Instructions will be seen by everyone with access to this record)

                                                    </div>


                                                    <div className="col-6 mb-3">
                                                        <label htmlFor="wo_case_instructions">CASE INSTRUCTIONS</label>
                                                        <textarea rows="3" name="wo_case_instructions" id="wo_case_instructions"
                                                            className="form-control"
                                                            onChange={(e) => {
                                                                setWo({ ...wo, wo_case_instructions: e.target.value })
                                                            }}
                                                            value={wo?.wo_case_instructions}

                                                        >
                                                        </textarea>

                                                    </div>

                                                </div>

                                            </>
                                            :
                                            <>
                                                <div className="row px-3 gx-3 pt-3 pb-1">

                                                    <div className="col-3 mb-3">
                                                        <label htmlFor="wo_order_type" >ORDER TYPE</label><br />
                                                        <label className="field-info" >{work_order?.wo_order_type}</label>



                                                    </div>
                                                    <div className="col-3 mb-3">
                                                        <label htmlFor="wo_request_submitted_by" >WO Requested By</label><br />
                                                        <label className="field-info tt-none" >{work_order?.wo_request_submitted_by}</label>



                                                    </div>




                                                    <div className="col-3 mb-3">
                                                        <label htmlFor="wo_policy_number" >POLICY NUMBER</label><br />
                                                        <label className="field-info tt-none" >{work_order?.wo_policy_number ? work_order?.wo_policy_number : ""}</label>



                                                    </div>









                                                    <div className="col-3 mb-3">
                                                        <label htmlFor="wo_insured">PURPOSE/INTENT</label><br />
                                                        <label className="field-info" >{work_order?.wo_insured ? work_order?.wo_insured : ""}</label>



                                                    </div>

                                                    <div className="col-3  mb-3">
                                                        <label htmlFor="wo_admit_date">ADMISSION TIME PERIOD</label><br />
                                                        <label className="field-info" >{work_order?.wo_admit_date ? work_order?.wo_admit_date : ""}</label>

                                                    </div>



                                                    {work_order?.wo_auth_submit &&
                                                        <div className="col-3 mb-3" >

                                                            <label htmlFor="patient_authorization" >HOW AUTH SUBMITTED</label> <br />
                                                            <label className="field-info" >{work_order.wo_auth_submit}</label>


                                                        </div>
                                                    }




                                                    <div className="col-3 mb-3">
                                                        <label htmlFor="wo_case_open">HOW CASE SUBMITTED</label><br />
                                                        <label className="field-info" >{work_order?.wo_case_open ? work_order?.wo_case_open : ""}</label>



                                                    </div>





</div>
<div className="row px-3 gx-3 pb-3" >

                                                    <div className="col-6">
                                                        <label htmlFor="wo_special_instructions">SPECIAL INSTRUCTIONS</label><br />
                                                        <label className="field-info tt-none" >{work_order?.wo_special_instructions ? work_order?.wo_special_instructions : ""}</label>


                                                    </div>
                                                    <div className="col-6">
                                                        <label htmlFor="wo_case_instructions">CASE INSTRUCTIONS</label><br />
                                                        <label className="field-info tt-none" >{work_order?.wo_case_instructions ? work_order?.wo_case_instructions : ""}</label>


                                                    </div>


                                                </div>

                                            </>
                                        }




                                        {work_order.status >= 1 && work_order.authorization_status == 1 &&
                                            <>
                                                <UploadRecord work_order={work_order} onWorkOrderChange={(e) => { onWorkOrderChange(e); }} />

                                                {work_order.status >= 4 &&
                                                    <Invoice work_order={work_order} onWorkOrderChange={(e) => { onWorkOrderChange(e); }} />
                                                }
                                            </>
                                        }
                                    </div>
                                </div>






                            </div>

                        </form>


                    }
                </div>



            </div>







        </>

    );
};

export default CaseInformation;